export default __webpack_public_path__ + "static/media/Rectangle 1027.ee4c0355.png";